import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-3Brfu",
  "use": "down-3Brfu-usage",
  "viewBox": "0 0 9 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 5\" id=\"down-3Brfu\"><path fill-rule=\"evenodd\" d=\"M4.5 4.09L0-.001h9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol